import { Tab } from '~/settings-scenario/types'

export const SETTINGS_LABEL_BY_TAB: Record<Tab, string> = {
  [Tab.PERSONAL_INFO]: 'personal-info',
  [Tab.PROFILE]: 'my-profile',
  [Tab.CURRICULUM]: 'curriculum',
  [Tab.AVATAR_NICKNAME]: 'avatar-nickname',
  [Tab.CHANGE_PASSWORD]: 'change-password',
}
